const accordionItems = document.querySelectorAll('.accordion-item');

function toggleAccordion() {
    this.classList.toggle('open');
}

accordionItems.forEach(item => item.addEventListener('click', toggleAccordion));

document.addEventListener('DOMContentLoaded', function () {
    const navLinks = document.querySelectorAll('.nav-link a');
    const currentUrl = window.location.href;

    navLinks.forEach(function (link) {
        if (link.href === currentUrl) {
            link.classList.add('active');
        }
    });
});




//custome code

document.addEventListener('DOMContentLoaded', function() {
    try {
        function hideSection() {
            try {
                const section = document.querySelector('#shopify-section-template--22842228900142__50e66c85-e812-4cf7-9e37-52c39895de65');
                
                if (!section) {
                    console.warn('Section element not found in the DOM');
                    return;
                }

                if (window.innerWidth <= 1090) {
                    section.style.display = 'none';
                } else {
                    section.style.display = '';
                }
            } catch (error) {
                console.error('Error in hideSection function:', error.message);
            }
        }

        hideSection();

        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(hideSection, 150);
        });

    } catch (error) {
        console.error('Error initializing section hide functionality:', error.message);
    }
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeScript);
} else {
    initializeScript();
}

function initializeScript() {
    try {
        const section = document.querySelector('#shopify-section-template--22842228900142__50e66c85-e812-4cf7-9e37-52c39895de65');
        
        if (!section) {
            console.warn('Target section not found');
            return;
        }

        console.log('Section hide functionality initialized successfully');
    } catch (error) {
        console.error('Error during script initialization:', error.message);
    }
}
